import { render } from "./SupportTicketRightbar.vue?vue&type=template&id=430786fe"
import script from "./SupportTicketRightbar.vue?vue&type=script&lang=js"
export * from "./SupportTicketRightbar.vue?vue&type=script&lang=js"

import "./SupportTicketRightbar.vue?vue&type=style&index=0&id=430786fe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__